<template>
  <div>
    <action-bar></action-bar>

    <main class="content">
      <div>
        <h1>Allgemeines Result erstellen</h1>
        <div class="form-group">
          <label for="name">Name</label>
          <input type="text" id="name" v-model="name" class="form-control">
        </div>
        <div class="form-group">
          <label for="name">Typ</label>
          <select type="text" id="type" v-model="type" class="form-control">
            <option value="BroadcastResult">Broadcast</option>
            <option value="FilmResult">Film</option>
            <option value="MediaReleaseResult">Media Release</option>
            <option value="NewspaperArticleResult">Zeitungsartikel</option>
            <option value="NonScientificPublicationResult">Non-Scientific Publication</option>
            <option value="PosterResult">Poster</option>
            <option value="PresentationResult">Präsentation</option>
            <option value="ScientificPublicationResult">Scientific Publication</option>
            <option value="WebProductResult">Web Product</option>
          </select>
        </div>
        <button class="btn btn-primary" @click="save">Erstellen</button>
      </div>
    </main>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: "",
      type: "BroadcastResult"
    };
  },
  methods: {
    save() {
      let form = new FormData();
      form.append("create_result[name]", this.name);
      form.append("create_result[type]", this.type);
      store.commit("addSavingProcess");
      axios
        .post(
          "/api/" +
            store.state.language +
            "/result/create",
          form
        )
        .then(({ data }) => {
          this.name = "";
          this.type = "BroadcastResult";
          store.commit("finishSavingProcess");
          this.$router.push({ name: 'result-list' });
        });
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/pages/admin/result/GeneralCreate.vue